"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function useTimeout(callback, delay) {
  react_1.default.useEffect(function () {
    var id = setTimeout(callback, delay);
    return function () {
      return clearTimeout(id);
    };
  }, [callback, delay]);
}

exports.useTimeout = useTimeout;